import React, { lazy, Suspense, useMemo, useState } from "react";
import LockedContainer from "../locked/LockedContainer";
import LoaderContainer from "../../../mui/loader_container/LoaderContainer";
import { useAppSelector } from "../../../../store/index.ts";
import { useTranslation } from "react-i18next";

import imgDepositInrEnH from "./img/deposit_horizontal_en.webp";
import imgDepositInrEnV from "./img/deposit_vertical_en.webp";
import imgDepositInrHiH from "./img/deposit_horizontal_hi.webp";
import imgDepositInrHiV from "./img/deposit_vertical_hi.webp";
import { ENUM_CURRENCY, ENUM_LANG } from "../../../../store/enums.js";
import ShowContainer from "../../../mui/ShowContainer.jsx";

const StepContainer = lazy(() => import("../StepContainer.jsx"));

export default function DepositContent({
  isOpen,
  closeModal,
  defaultDeposit,
  setOpenPaymentCard,
  setOpenPaymentPhone
}) {
  const { t } = useTranslation();

  const currency = useAppSelector((state) => state.user.currency);
  const lang = useAppSelector((state) => state.common.lang);
  const isLessTablet = useAppSelector((state) => state.deviceSize.isLessTablet);

  const [lockedInfo, setLockedInfo] = useState(false);
  const [step, setStep] = useState(1);

  const title = useMemo(
    () =>
      currency ? t("Top up your balance in", { currency: currency }) : t("Top up your balance"),
    [currency, t]
  );

  const imgUrl = useMemo(() => {
    const langEn = lang == ENUM_LANG.en;
    const langHi = lang == ENUM_LANG.hi;

    const isInr = currency == ENUM_CURRENCY.INR;

    if (isLessTablet) {
      if (langEn) {
        if (isInr) return imgDepositInrEnH;
      }
      if (langHi) {
        if (isInr) return imgDepositInrHiH;
      }
    }

    if (langEn) {
      if (isInr) return imgDepositInrEnV;
    }
    if (langHi) {
      if (isInr) return imgDepositInrHiV;
    }

    return "";
  }, [currency, lang, isLessTablet]);

  console.log("isLessTablet", isLessTablet);

  const isEmptyImg = !imgUrl || step != 1;
  const wrapperClass = isEmptyImg ? "empty" : "";

  return (
    <div className={`top-up-balance__wrapper ${wrapperClass}`}>
      <ShowContainer condition={!isEmptyImg}>
        <div className="top-up-balance__wrapper__img">
          <img src={imgUrl} alt="deposit img" className="top-up-balance__wrapper__img" />
        </div>
      </ShowContainer>

      <div className="top-up-balance__content">
        <LockedContainer locked={lockedInfo?.locked} lockedInfo={lockedInfo}>
          <h2>{title}</h2>

          <Suspense fallback={<LoaderContainer center />}>
            <StepContainer
              defaultDeposit={defaultDeposit}
              isOpen={isOpen}
              closeModal={closeModal}
              setLockedInfo={setLockedInfo}
              lockedInfo={lockedInfo}
              setOpenPaymentCard={setOpenPaymentCard}
              setOpenPaymentPhone={setOpenPaymentPhone}
              step={step}
              setStep={setStep}
            />
          </Suspense>
        </LockedContainer>
      </div>
    </div>
  );
}
